import axios from "axios";

// const API_URL = "https://app.theshetu.com/api/v1/admin/auth";
const API_URL = `${process.env.REACT_APP_API_URL}/auth`;
const apiClient = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});
apiClient.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.accessToken) {
      config.headers.Authorization = `Bearer ${user.accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const forgotPassword = async (email) => {
  const response = await apiClient.post("/forgot-password", { email });
  return response.data;
};

export const resetPassword = async (token, newPassword) => {
  const response = await apiClient.post(`/reset-password/${token}`, {
    newPassword,
  });
  return response.data;
};
